import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=b1b94c9e&"
import script from "./goals.vue?vue&type=script&lang=js&"
export * from "./goals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports